import SwitchWithLabel from "@/components/SwitchWithLabel/SwitchWithLabel";
import { UniqueRouteLeg } from "@/hooks/useTransport";
import { PlusOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Select } from "antd";
import axios from "axios";
import styles from "./RouteWizard.module.scss";

export default function TransportMode({
  leg,
  index,
  updateLeg,
  addLeg,
  error,
}: {
  leg: UniqueRouteLeg;
  index: number;
  updateLeg: (index: number, leg: UniqueRouteLeg) => void;
  addLeg: (index: number) => void;
  error: boolean;
}) {
  const { data: options, isLoading: optionsLoading } = useQuery({
    queryKey: ["transport-options"],
    queryFn: () =>
      axios
        .get<{ options: { label: string; urn: string }[] }>("transport/options")
        .then((data) => data.data),
  });

  return (
    <div className={styles.leg}>
      <div className={styles.bullet}>
        <div className={styles["bullet-wrapper"]}></div>
      </div>
      <div className={styles.mode}>
        <Select
          allowClear={true}
          status={error ? "error" : undefined}
          style={{ width: 200 }}
          placeholder="Choose transport mode"
          value={leg.mode}
          loading={optionsLoading}
          onChange={(value) => updateLeg(index, { ...leg, mode: value })}
          options={options?.options.map((option) => ({ label: option.label, value: option.urn }))}
        />
        <SwitchWithLabel
          size="small"
          onChange={(value) => updateLeg(index, { ...leg, owned: value })}
          checked={leg.owned}
          tooltip="If you own or lease the vehicle for a transport leg, the carbon emissions generated during transport fall under scope 1 emissions for combustion vehicles and scope 2 emissions for electric vehicles."
        >
          Owned or leased
        </SwitchWithLabel>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => addLeg(index)}
        >
          Insert leg
        </Button>
      </div>
    </div>
  );
}
